import React from 'react';
import { render } from 'react-dom';
import App from '../components/app';
import { store } from '../redux/store';
import { Provider } from 'react-redux';
import { loadAllSettings } from 'travco-services';
import { OidcProvider } from 'redux-oidc';
import { setupUserManager, userManager } from '../utils/user-manager';

// Hook up the setupUserManager on store changes, since we need to wait for the settings
let unsubscribe = store.subscribe(function() {
    setupUserManager(store.getState().settings);
});
// Load initial state.
store.dispatch(loadAllSettings());

let renderIfReady = function() {
    // We defer rendering until the userManager is up, otherwise the OidcProvider throws a wobbler
    if (userManager) {
        unsubscribe();
        render(
            <Provider store={store}>
                <OidcProvider store={store} userManager={userManager}>
                    <App />
                </OidcProvider>
            </Provider>,
            document.getElementById('app')
        );
    } else {
        setTimeout(renderIfReady, 500);
    }
};

setTimeout(renderIfReady, 500);
